module.exports = __webpack_public_path__ + "img/BeYou-Health-Bar-Design-Tashii-Designs-packages.0077d3fb.jpg";